class VwRadyolojiIslemleriDTO {
    id: number = null;
    kimlikId?: number = null;
    muracaatId?: number = null;
    hastaservisId?: number = null;
    organizasyonId?: number = null;
    tarih?: string = null;
    servisId?: number = null;
    doktorId?: number = null;
    aciklama?: string = "";
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    iptal?: string = "";
    iptalKullanici?: number = null;
    iptalTarihi?: string = null;
    redTarih?: string = null;
    redKullanici?: number = null;
    redNedenId?: number = null;
    redAciklama?: string = "";
    servisAdi?: string = "";
    organizasyonAdi?: string = "";
    doktorAdiSoyadi?: string = "";
    orderRadyolojiId?: number = null;
    orderDetayId?: number = null;
    acil?: string = "";
    kabulTarihi?: string = null;
    cekimTarihi?: string = null;
    kabulEdenId?: number = null;
    cihazId?: number = null;
    taraf?: number = null;
    hastaAdiSoyadi?: string = "";
    orderId?: number = null;
    kurumId?: number = null;
    kimlikNo?: string = "";
    islemAdi?: string = "";
    islemTanimId?: number = null;
    onaytarih?: string = null;
    numunedurum?: number = null;
    raportiptanimId?: number = null;
    radDokor?: string = "";
    //View dışı
    onayladaAktar?: string = "";
}
export default VwRadyolojiIslemleriDTO;